export const SEARCH_PANEL_PREFIX = "SearchPanel";

export const SEARCH_PANEL_CLASSES = {
  element: `${SEARCH_PANEL_PREFIX}-element`,
  elements: `${SEARCH_PANEL_PREFIX}-elements`,
  popular: `${SEARCH_PANEL_PREFIX}-popular`,
  divider: `${SEARCH_PANEL_PREFIX}-divider`,
  needHelp: `${SEARCH_PANEL_PREFIX}-needHelp`,
};
